export default {
  contract: {}
}
